export default __webpack_public_path__ + "static/media/mexico-circle.d2f436b4.svg";